export const StorageService = {
    saveInLocalStorage,
    saveInSessionStorage,
    getFromLocalStorage,
    getFromSessionStorage,
    removeItemInLocalStorage,
    removeItemInSessionStorage
  };

  function saveInLocalStorage(key,value){
    window.localStorage.setItem(key,value);
  } 

  function saveInSessionStorage(key,value){
    window.sessionStorage.setItem(key,value);
  } 

 function getFromLocalStorage(key){
   return window.localStorage.getItem(key)
 } 


 function getFromSessionStorage(key){
    return window.sessionStorage.getItem(key)
 } 

 function removeItemInLocalStorage(key){
  window.localStorage.removeItem(key);
} 

function removeItemInSessionStorage(key){
  window.sessionStorage.removeItem(key);
} 


